import React, { useState } from "react";
import reportTypes from "../utils/report_types";
import "./Reports.css";
import { decryptFile } from "../utils/decrypt";
import ComparativaTotales from "../reports/ComparativaTotales";
import ComparativaTotalesChart from "../reports/ComparativaTotalesChart";

const secretKeyEncrypt = "DSFG7FG787";

const Reports = () => {
  const [jsonData, setJsonData] = useState(null);
  const [error, setError] = useState("");
  const [selectedReport, setSelectedReport] = useState("");

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const decrypted = decryptFile(e.target.result, secretKeyEncrypt);
      if (!decrypted) {
        setError("Error al desofuscar el JSON");
        return;
      }

      try {
        const parsed = JSON.parse(decrypted);
        setJsonData(parsed);
        setError("");
        console.log("JSON desencriptado:", parsed); // Solo en consola
      } catch (err) {
        setError("JSON inválido después de desofuscar");
      }
    };
    reader.readAsText(file);
  };

  const keysPresentes = jsonData ? Object.keys(jsonData) : [];

  return (
    <div className="reports-container">
      <h2>Subir y Desencriptar JSON</h2>

      <div className="file-input-wrapper">
        <input type="file" accept=".json" onChange={handleFileUpload} />
      </div>

      {error && <p className="reports-error">{error}</p>}

      {jsonData && (
        <>
            <label>Selecciona un informe:</label>
            <select
            value={selectedReport}
            onChange={(e) => setSelectedReport(e.target.value)}
            >
            <option value="">-- Elegir --</option>
            {reportTypes
                .filter((r) => r.keys.every((k) => Object.keys(jsonData).includes(k)))
                .map((r) => (
                <option key={r.id} value={r.id}>
                    {r.label}
                </option>
                ))}
            </select>

            {selectedReport === "report-comparativa-mensual-totales" && jsonData && (
               <>
                    <ComparativaTotales data={jsonData} />
                    <ComparativaTotalesChart data={jsonData} />
                </>
            )}
        </>
        )}

    </div>
  );
};

export default Reports;
